const baseHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const buildHeaders = (customHeaders) => ({
  ...baseHeaders,
  ...(customHeaders || {}),
});

const get = async (url, options = {}) => {
  try {
    const { headers, ...restOptions } = options;
    const response = await fetch(url, {
      method: "GET",
      headers: buildHeaders(headers),
      ...restOptions,
    });
    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

const post = async (url, payload, options = {}) => {
  try {
    const { headers, body, ...restOptions } = options;
    const response = await fetch(url, {
      method: "POST",
      headers: buildHeaders(headers),
      body: body !== undefined ? body : JSON.stringify(payload),
      ...restOptions,
    });
    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

const put = async (url, payload, options = {}) => {
  try {
    const { headers, body, ...restOptions } = options;
    const response = await fetch(url, {
      method: "PUT",
      headers: buildHeaders(headers),
      body: body !== undefined ? body : JSON.stringify(payload),
      ...restOptions,
    });
    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
};

export { get, post, put };
